export default __webpack_public_path__ + "static/media/linkedin.8f3ee2e4.svg";